import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../../contexts/UserContext';
import { DataTable, Notifications } from '../../../../shared';
import { SkuTabExpansion } from './skuTabExpansion';
import { WarehouseInventoryV2Api } from '../../../../api/warehouseInventoryV2';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import { CircularProgressOverlay } from './CircularProgressOverlay';

const warehouseInventoryV2Api = new WarehouseInventoryV2Api();

const SkuTab = ({ onLinkClicked, queryParams }) => {
    const [notification, setNotification] = useState({ text: null, level: null });
    const [rows, setRows] = useState([]);
    const [loadingSkus, setLoadingSkus] = useState(false);
    const [viewActions, setViewActions] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const user = useContext(UserContext);
    const [displayedType, setDisplayedType] = useState({ items: true, packaging: true });
    const [filteredRows, setFilteredRows] = useState([]);

    //search bar queryParams effect
    useEffect(() => {
        handleSearch();
    }, [queryParams]);

    useEffect(() => {
        setFilteredRows(rows);
    }, [rows]);

    useEffect(() => {
        if (displayedType.items && !displayedType.packaging) {
            setFilteredRows(rows.filter((row) => row.type !== 'PACKAGING'));
        } else if (!displayedType.items && displayedType.packaging) {
            setFilteredRows(rows.filter((row) => row.type !== 'ITEM'));
        } else if (!displayedType.items && !displayedType.packaging) {
            setFilteredRows([]);
        } else {
            setFilteredRows(rows);
        }
    }, [displayedType]);

    const handleSearch = async () => {
        getSkus();
    };

    //Column Definitions
    const columns = [
        { Header: 'External SKU', accessor: 'externalSku' },
        { Header: 'Partner SKU', accessor: 'partnerSku' },
        { Header: 'Item Name', accessor: 'itemName' },
        { Header: 'Pallets', accessor: 'numPallets' },
        { Header: 'Cases', accessor: 'numCases' },
        { Header: 'Loose Units', accessor: 'numLooseUnits' },
        { Header: 'Total Units', accessor: 'numTotalUnits' },
    ];

    //API call to GET data
    const getSkus = async () => {
        setLoadingSkus(true);
        const searchValues = [{ searchBy: queryParams.searchBy, searchTerm: queryParams.searchTerm }];

        if (queryParams.type) {
            searchValues.push({ searchBy: 'type', searchTerm: queryParams.type });
        }
        const result = await warehouseInventoryV2Api.getSkus(user.getFacilityID(), searchValues);
        if (result.status) {
            setRows(
                result.data.skus.map((sku) => {
                    return {
                        ...sku,
                    };
                })
            );
        } else {
            setNotification({ text: result.msg, level: 'error' });
        }
        setLoadingSkus(false);
    };

    const handleOnRowClicked = (row) => {
        setSelectedRow(row.original);
    };

    const handleSuccess = () => {
        setNotification({ text: 'Success', level: 'success' });
        getSkus();
    };

    const handleDisplayTypeChange = (event) => {
        setDisplayedType({ ...displayedType, [event.target.name]: event.target.checked });
    };

    return (
        <>
            <Notifications options={notification} />
            <CircularProgressOverlay loading={loadingSkus} />
            <>
                <FormControlLabel
                    control={<Checkbox checked={displayedType.items} onChange={handleDisplayTypeChange} name="items" />}
                    label="Finished Goods"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={displayedType.packaging}
                            onChange={handleDisplayTypeChange}
                            name="packaging"
                        />
                    }
                    label="Packaging"
                />
                <DataTable
                    csvExport={true}
                    csvExportFileName="sku_inventory"
                    columns={columns}
                    data={filteredRows}
                    editable={false}
                    tableContainerMaxHeight={800}
                    initialRowsPerPage={100}
                    stickyHeader={true}
                    expandable={true}
                    ExpansionComponent={
                        <SkuTabExpansion
                            externalSku={selectedRow?.externalSku}
                            onSuccess={handleSuccess}
                            type={selectedRow?.type}
                            onLinkClicked={onLinkClicked}
                        />
                    }
                    onRowClicked={handleOnRowClicked}
                />
            </>
        </>
    );
};

export { SkuTab };
